export default __webpack_public_path__ + "static/media/lastlink.3717a105.png";